import { render, staticRenderFns } from "./RequirementGroup.vue?vue&type=template&id=05a1d02b&"
import script from "./RequirementGroup.vue?vue&type=script&lang=js&"
export * from "./RequirementGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports